import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Sparkles, Loader2, AlertCircle, Info } from 'lucide-react';
import { sponsorApi } from '../../api';

export default function SponsorLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr(''); setBusy(true);
    try {
      await sponsorApi.login(email.trim().toLowerCase(), password);
      nav('/sponsor');
    } catch (e2) {
      setErr(e2.response?.data?.detail || 'Login fallito');
    } finally { setBusy(false); }
  };

  const useDemo = () => { setEmail('demo@yup.it'); setPassword('demo123'); };

  return (
    <div className="min-h-screen flex items-center justify-center p-4"
         style={{ background: 'radial-gradient(circle at 30% 20%, #1a1a1a, #000)' }}>
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-widest text-black mb-4"
               style={{ background: 'linear-gradient(135deg, #f2e5b8, #BCAC8A)' }}>
            <Sparkles size={12}/> Portale Sponsor YUP
          </div>
          <h1 className="text-white text-3xl font-bold" style={{ fontFamily: "'Playfair Display', serif" }}>Accedi al tuo account</h1>
          <p className="text-white/60 text-sm mt-2">Gestisci la tua scheda, le offerte e le statistiche</p>
        </div>

        <form onSubmit={submit} className="bg-black/60 backdrop-blur-md border border-[color:var(--yup-primary)]/40 rounded-2xl p-6 space-y-4" data-testid="sponsor-login-form">
          <div>
            <label className="block text-xs uppercase tracking-widest text-white/60 font-semibold mb-2">Email</label>
            <input type="email" required value={email} onChange={e => setEmail(e.target.value)} autoComplete="username"
                   data-testid="sponsor-login-email"
                   className="w-full bg-white/5 border border-white/15 rounded-lg px-3 py-3 text-white text-base focus:outline-none focus:border-[color:var(--yup-primary)]" />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-widest text-white/60 font-semibold mb-2">Password</label>
            <input type="password" required value={password} onChange={e => setPassword(e.target.value)} autoComplete="current-password"
                   data-testid="sponsor-login-password"
                   className="w-full bg-white/5 border border-white/15 rounded-lg px-3 py-3 text-white text-base focus:outline-none focus:border-[color:var(--yup-primary)]" />
          </div>
          {err && <div className="flex items-start gap-2 text-red-400 text-sm p-2 rounded bg-red-500/10" data-testid="sponsor-login-error"><AlertCircle size={16}/> {err}</div>}
          <button type="submit" disabled={busy}
                  data-testid="sponsor-login-submit"
                  className="w-full inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full font-bold text-black text-sm uppercase tracking-wider disabled:opacity-60"
                  style={{ background: 'linear-gradient(135deg, #f2e5b8, #BCAC8A)' }}>
            {busy ? <><Loader2 size={16} className="animate-spin"/> Accesso...</> : 'Accedi'}
          </button>

          <div className="pt-3 border-t border-white/10 text-center">
            <button type="button" onClick={useDemo} className="inline-flex items-center gap-2 text-xs text-[color:var(--yup-primary)] hover:brightness-125" data-testid="sponsor-login-demo-btn">
              <Info size={12}/> Prova con l'account demo (demo@yup.it / demo123)
            </button>
          </div>
        </form>

        <div className="mt-6 text-center text-white/40 text-xs">
          Non hai ancora un account sponsor? <Link to="/promuoviti" className="text-[color:var(--yup-primary)] underline">Candida la tua attività</Link>
        </div>
      </div>
    </div>
  );
}
